import { kubernetesLiveUsageMgmtSliceSelector } from "./kubernetesLiveUsageMgmtSliceSelector";
import { RootState } from "../../../store";

export const kubernetesLiveUsageMgmtViewWithoutFiltersResourceTypes = (
  state: RootState,
) => {
  return kubernetesLiveUsageMgmtSliceSelector(state)
    .viewWithoutFiltersResourceTypes;
};
